import { Box, Button, keyframes, Typography, useTheme } from "@mui/material";
import { memo, useState } from "react";

import CustomButton from "../../../../../../components/CustomButton";
import BoxChecked from "../../../../../../../media/images/icons/boxchecked";
import ArrowTickDown from "../../../../../../../media/images/icons/arrow-tick-down";
import DetailsLable from "./DetailsLable";
import CallSVG from "../../../../../../../media/images/icons/call";
import CalendarCheck from "../../../../../../../media/images/icons/calendar-check";
import { convertToJalali } from "../../../../../../../utils/functions";
import TenderOfferModal from "../TenderOfferModal";
import GetCargoModal from "../GetCargoModal";
import LocationSVG from "../../../../../../../media/images/icons/location";
import MapBoxBottomSheet from "./MapBoxBottomSheet";
import { Link } from "react-router-dom";
import { digitsEnToFa } from "@persian-tools/persian-tools";
import { IOrder } from "../../../../../../../types/driver";

const rotateBorder = keyframes`
    0% {
                background-position: top ;
            }
            25% {
                background-position: right;
            }
            50% {
                background-position: bottom;
            }
            75% {
                background-position: left;
            }
            100% {
                background-position: top;
            }
`;
const scale = keyframes`
  from {
    scale: 0.8;
  }
  to {
    scale: 1;

  }
`;
const FerightDetails = (props: IOrder) => {
  const theme = useTheme();

  const [open, setOpen] = useState(false);
  const [mapOpen, setMapOpen] = useState(false);
  const [tenderOfferModal, settenderOfferModal] = useState(false);
  const [getCargoModal, setGetCargoModal] = useState(false);

  const {
    companyName,
    description,
    ladingLocationInfoAddress,
    ladingLocationInfoLat,
    ladingLocationInfoLng,
    packageTypeName,
    orderDateEn,
    orderId,
    weight,
    remainder,
    id,
    companyTel,
    truckWeight,
    truckWeightTo,
  } = props;

  return (
    <>
      <MapBoxBottomSheet
        getAddress={(str) => console.log(str)}
        open={mapOpen}
        onDismiss={() => setMapOpen(false)}
        center={
          ladingLocationInfoLat && ladingLocationInfoLng
            ? { lat: ladingLocationInfoLat, lng: ladingLocationInfoLng }
            : null
        }
      />
      <TenderOfferModal
        handleClose={() => settenderOfferModal(false)}
        open={tenderOfferModal}
        orderId={id}
      />
      <GetCargoModal
        open={getCargoModal}
        handleClose={() => setGetCargoModal(false)}
        {...props}
      />

      <Box
        sx={{
          height: "100%",
          mt: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            // alignItems: "center",
            // padding: "4px 8px",
            // height: "50px",
            // backgroundColor: "info.light",
            // border: "1px solid gray",
          }}
        >
          <Box
            sx={{
              width: "80px",
              transition: "all 0.3s",
              // border: "1px solid gray",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "8px 8px 0px 0px",
              overflow: "hidden",
              padding: "4px",
              backgroundColor: open ? "bgColor.grey100" : "",
              boxShadow: open
                ? "4px 4px 5px -4px rgba(0, 0, 0, 0.1) inset, -4px 4px 5px -4px rgba(0, 0, 0, 0.1) inset"
                : "",
            }}
          >
            <Button
              onClick={() => setOpen((prev) => !prev)}
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                borderRadius: "6px",
                alignItems: "center",
                border: "1px solid gray",
                minWidth: "0px !important",
                height: "fit-content",
                padding: "8px 8px",

                borderColor: open
                  ? `${theme.palette.error.main} !important`
                  : `${theme.palette.secondary.main} !important`,
                backgroundColor: open
                  ? `${theme.palette.error.light} !important`
                  : `${theme.palette.secondary[50]} !important`,
                "& .MuiTouchRipple-root": {
                  color: `${theme.palette.secondary.main} !important`,
                  borderWidth: "0px !important",
                },
                "& .MuiButtonBase-root": {
                  color: `${theme.palette.error.main} !important`,
                  borderWidth: "0px !important",
                  minWidth: "0px !important",
                },
                "& .MuiButton-root": {
                  minWidth: "0px !important",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                  animation: open ? "" : `${scale} alternate 1s infinite`,
                }}
              >
                <Typography
                  //
                  sx={{
                    color: open ? "error.main" : "secondary.main",
                    whiteSpace: "nowrap",
                    fontSize: "12px",
                  }}
                >
                  {open ? "بستن جزییات" : "جزییات بار"}
                </Typography>
                <Box
                  sx={{
                    transform: open ? "rotate(180deg)" : "",
                    transition: "all 0.3s",
                  }}
                >
                  <ArrowTickDown
                    size={14}
                    color={
                      open
                        ? theme.palette.error.main
                        : theme.palette.secondary.main
                    }
                  />
                </Box>
              </Box>
            </Button>
          </Box>
          <Box
            sx={{
              flex: 1,
              display: "flex",
              gap: "8px",
              paddingY: "8px",
              paddingRight: "8px",
              borderRadius: "0px 0px -8px 0px",
              boxShadow: open
                ? "4px 4px 10px -4px rgba(0, 0, 0, 0.1), 8px 4px 10px -4px rgba(0, 0, 0, 0.1) "
                : "",
              zIndex: "50",
            }}
          >
            {/* <CustomButton
              className="animateButton"
              flexDirection="row-reverse"
              onClick={() => settenderOfferModal(true)}
              title="پیشنهاد  کرایه"
              justifyContent="center"
              bgColor={theme.palette.primary.main}
              textColor="#fff"
              px="10px"
              py="16px"
              borderRadius="10px"
            /> */}
            <Button
              onClick={() => settenderOfferModal(true)}
              sx={{
                position: "relative",
                flex: 1,
                display: "flex",
                flexDirection: "column",
                borderRadius: "6px",
                alignItems: "center",
                // border: "1px solid gray",
                minWidth: "0px !important",
                padding: "6px 4px",

                // borderColor: open
                //   ? `${theme.palette.error.main} !important`
                //   : `${theme.palette.secondary.main} !important`,
                backgroundColor: theme.palette.primary[50],
                "& .MuiTouchRipple-root": {
                  color: `${theme.palette.primary.main} !important`,
                  borderWidth: "0px !important",
                },
                "& .MuiButtonBase-root": {
                  color: `${theme.palette.error.main} !important`,
                  borderWidth: "0px !important",
                  minWidth: "0px !important",
                },
                "& .MuiButton-root": {
                  minWidth: "0px !important",
                },
                // "& .MuiButton-root:hover &::after": {
                //   display: "none",
                // },
                // "&.MuiButtonBase-root:hover &::after": {
                //   display: "none",
                // },

                "&::after": {
                  content: "''",
                  position: "absolute",
                  top: "-2px",
                  left: "-2px",
                  right: "-2px",
                  bottom: "-2px",
                  // width: "10px",
                  // backgroundColor: "#000",
                  border: "2px solid transparent",
                  // backgroundSize: "400% 400%",
                  // height: "32px",
                  // top: -"2px",
                  // left: -"2px",
                  // right: -"2px",
                  // bottom: -"2px",
                  // border: "2px solid transparent",
                  borderRadius: "5px",
                  // backgroundColor: "red",
                  background:
                    "radial-gradient(circle, rgba(23,131,240,1) 0%, rgba(255,255,255,1) 30%)",
                  backgroundSize: "200% 200%",
                  zIndex: -1,
                  animation: `${rotateBorder} 3s linear infinite`,
                },
                "&:hover::after": {
                  transitionDuration: "1s",
                  border: "2px solid",
                  borderColor: "primary.main",
                  background: "none",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                  // animation: open ? "" : `${scale} alternate 1s infinite`,
                }}
              >
                <Typography
                  //
                  sx={{
                    color: "primary.main",
                    whiteSpace: "nowrap",
                    fontSize: "16px",
                    fontWeight: "700",
                  }}
                >
                  {"پیشنهاد  کرایه"}
                </Typography>
              </Box>
            </Button>
            <CustomButton
              flex={1}
              // loading
              flexDirection="row-reverse"
              onClick={() => setGetCargoModal(true)}
              title="دریافت بار"
              justifyContent="center"
              bgColor="success.main"
              textColor="#fff"
              fSize="16px"
              px="10px"
              py="14px"
              borderRadius="10px"
              icon1={<BoxChecked size={26} color={"#fff"} />}
            />
          </Box>
        </Box>
        <Box
          sx={{
            maxHeight: open ? "500px" : "0px",
            transition: "max-height 0.3s",
            overflow: "hidden",
            overflowY: open ? "auto" : "hidden",
            display: "flex",
            flexDirection: "column",
            gap: "6px",
            backgroundColor: "bgColor.grey100",
            borderRadius: "8px 0px 8px 8px",

            paddingX: "8px",
            boxShadow:
              "8px -4px 5px -8px rgba(0,0,0,0.1) inset , 4px -2px 5px -3px rgba(0,0,0,0.05) inset, -4px -6px 10px -4px rgba(0,0,0,0.1) inset",
          }}
        >
          <Box
            sx={{
              display: "flex",
              pt: 2,
              gap: "8px",
            }}
          >
            <Box
              sx={{
                flex: "1",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <DetailsLable>
                <Typography
                  noWrap
                  sx={{
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                >
                  تاریخ ثبت سفارش:
                </Typography>
                <Typography
                  sx={{
                    alignSelf: "end",
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                  color={"primary.main"}
                >
                  {convertToJalali(orderDateEn)}
                </Typography>
              </DetailsLable>
              <DetailsLable>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                >
                  شرکت حمل و نقل:
                </Typography>
                <Typography
                  sx={{
                    alignSelf: "end",
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                  color={"primary.main"}
                >
                  {companyName}
                </Typography>
              </DetailsLable>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <CustomButton
                // loading={loading}
                onClick={() => setMapOpen(true)}
                flexDirection="row"
                title="محل بارگیری"
                justifyContent="center"
                borderColor="secondary.main"
                bgColor={theme.palette.secondary[50]}
                textColor="secondary.main"
                fSize="10px"
                px="10px"
                py="10px"
                borderRadius="10px"
                icon1={
                  <LocationSVG size={16} color={theme.palette.secondary.main} />
                }
              />
              {companyTel?.length && (
                <a href={`tel:${companyTel}`} style={{ textDecoration: "none" }}>
                  <CustomButton
                    flexDirection="row"
                    title="اطلاعات تماس"
                    justifyContent="center"
                    borderColor="success.main"
                    bgColor={theme.palette.success.light}
                    textColor="success.main"
                    fSize="10px"
                    px="10px"
                    py="10px"
                    borderRadius="10px"
                    icon1={
                      <CallSVG size={16} color={theme.palette.success.main} />
                    }
                  />
                </a>
              )}
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              gap: "8px",
            }}
          >
            <DetailsLable>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                شماره سفارش:
              </Typography>
              <Typography
                sx={{
                  alignSelf: "end",

                  fontSize: "14px",
                  fontWeight: "700",
                }}
                color={"secondary.main"}
              >
                {orderId}
              </Typography>
            </DetailsLable>
            <DetailsLable>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <CalendarCheck size={16} color={theme.palette.textColor.dark} />
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                >
                  بسته بندی:
                </Typography>
              </Box>
              <Typography
                sx={{
                  alignSelf: "end",
                  fontSize: "14px",
                  fontWeight: "700",
                }}
                color={"secondary.main"}
              >
                {packageTypeName}
              </Typography>
            </DetailsLable>
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: "8px",
            }}
          >
            <DetailsLable>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                تعداد:
              </Typography>
              <Typography
                sx={{
                  alignSelf: "end",

                  fontSize: "14px",
                  fontWeight: "700",
                }}
                color={"secondary.main"}
              >
                {remainder} عدد
              </Typography>
            </DetailsLable>
            <DetailsLable>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <CalendarCheck size={16} color={theme.palette.textColor.dark} />
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                >
                  تناژ:
                </Typography>
              </Box>
              <Typography
                sx={{
                  alignSelf: "end",

                  fontSize: "14px",
                  fontWeight: "700",
                }}
                color={"secondary.main"}
              >
                {truckWeightTo != null
                  ? `از ${digitsEnToFa((truckWeight ?? 0) / 1000)} تن تا ${digitsEnToFa(truckWeightTo / 1000)} تن`
                  : `${digitsEnToFa(weight)} تن`}
              </Typography>
            </DetailsLable>
          </Box>
          <Box>
            <DetailsLable>
              <Box
                sx={{
                  display: "flex",
                }}
              >
                <CalendarCheck size={16} color={theme.palette.textColor.dark} />
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                >
                  محل بارگیری:
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                }}
                color={"primary.main"}
              >
                {ladingLocationInfoAddress}
              </Typography>
            </DetailsLable>
          </Box>
          <Box
            sx={{
              mb: 1,
              width: "100%",
              minWidth: 0,
            }}
          >
            <DetailsLable>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  mb: 8,
                  minWidth: 0,
                  width: "100%",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                  color={"secondary.main"}
                >
                  توضیحات بار:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "700",
                    whiteSpace: "normal",
                    overflowWrap: "break-word",
                    wordBreak: "break-word",
                  }}
                >
                  {description}
                </Typography>
              </Box>
            </DetailsLable>
          </Box>

          {/* <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "4px",
            paddingX: "8px",
            paddingY: "8px",
            borderRadius: "8px",
            backgroundColor: "#424242",
          }}
        >
          <img src={KarenCoin} alt="" />
          <Typography color={"#FFD54F"}>{digitsEnToFa(475)}</Typography>
          <Typography color={"#FFD54F"}>امتیاز</Typography>
        </Box> */}
        </Box>
      </Box>
    </>
  );
};

export default memo(FerightDetails);
